import { Link } from 'react-router-dom';
import { CloseIcon, HamburgerIcon, MoonIcon, SunIcon } from './Icons';

const NAV_LINKS = [
  { href: '/#gallery', label: 'Gallery' },
  { href: '/#services', label: 'Services' },
  { href: '/#contact', label: 'Contact Us' },
  { href: '/faq', label: 'FAQ' },
];

const Navbar = ({
  isOpen,
  setIsOpen,
  theme,
  toggleTheme,
  logoSrc,
  handleNavClick,
  isScrolled,
}) => (
  <header>
    <nav
      className={`nav ${isScrolled ? 'scrolled' : ''}`}
      aria-label="Main navigation"
    >
      <Link
        to="/"
        className="nav__logo"
        aria-label="PaveMend – go to home"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <img className="nav__logo-img" src={logoSrc} alt="PaveMend logo" />
      </Link>

      <ul
        className={`nav__links ${isOpen ? 'is-open' : ''}`}
        onClick={handleNavClick}
        id="navLinks"
      >
        {NAV_LINKS.map((link) => (
          <li key={link.href}>
            <a href={link.href}>{link.label}</a>
          </li>
        ))}

        <li className="nav__links-cta">
          <Link to="/booking" className="nav__cta">
            Get a Quote
          </Link>
        </li>
      </ul>

      <div className="nav__actions">
        <button
          className="nav__theme-toggle"
          type="button"
          aria-label={
            theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
          }
          onClick={toggleTheme}
        >
          {theme === 'dark' ? (
            <SunIcon size={18} ariaHidden />
          ) : (
            <MoonIcon size={18} ariaHidden />
          )}
        </button>

        <button
          className="nav__toggle"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="navLinks"
        >
          {isOpen ? (
            <CloseIcon size={22} ariaHidden />
          ) : (
            <HamburgerIcon size={22} ariaHidden />
          )}
        </button>
      </div>
    </nav>
  </header>
);

export default Navbar;
